<template>
  <div class="form-group mb-25">
    <label class="d-block fs-14 text-black mb-2">Paper Size</label>
    <select class="bg-white border-0 rounded-1 fs-14 text-optional">
      <option value="0">30 per sheet(A4)</option>
      <option value="0">35 per sheet(A4)</option>
      <option value="0">40 per sheet(A4)</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "PaperSize",
};
</script>